<template>
  <div class="dates-container">
    <ul class="list">
      <li
        v-for="(option, index) in currentOptions"
        :key="option"
        class="item"
      >
        <label
          class="label"
          :class="{
            white: index === selected,
          }"
          :for="`${id}-${option}`"
          @click="updateValue(index)"
        >
          {{ option }}
        </label>
        <input
          :id="`${id}-${option}`"
          v-model="selected"
          type="radio"
          :checked="selected === index"
          :value="index"
          @change="updateValue(index)"
        />
      </li>
    </ul>
    <div class="descriptionContainer fade-in" v-if="selected !== undefined">
      <span class="dueDateDescription"
        >Vencimento todo dia
        {{ currentOptions[selected] }}</span
      >
      <span class="bestDayToBuy"
        >Dia
        {{ getBestDayToBuy(currentOptions[selected]) }} é
        o melhor dia para compras</span
      >
    </div>
  </div>
</template>
<script>
import { ref, defineComponent } from 'vue';
import moment from '@/lib/moment-ptbr';

export default defineComponent({
  name: 'InstallmentDateSelect',
  props: {
    id: {
      default: Math.random().toString(36).substring(2, 10),
      type: String,
    },
    currentOptions: {
      type: Array,
      default: () => [],
    },
  },
  emits: ['selectedDate'],
  setup(props, { emit }) {
    const selected = ref();

    function updateValue(option) {
      selected.value = option;
      emit('selectedDate', props.currentOptions[selected.value]);
    }

    function getBestDayToBuy(date) {
      return moment().date(date).subtract(7, 'days').format('D');
    }

    return {
      selected,
      getBestDayToBuy,
      updateValue,
    };
  },
});
</script>
<style lang="scss" scoped>
input[type="radio"] {
  padding: 0;
  margin: 0;
  border-radius: 0.75rem;
  width: 3rem;
  height: 3rem;
  border: none;
  background-color: #f3f4f6;
  appearance: none;
}

input[type="radio"]:checked {
  appearance: none;
  background-color: #ed0059;
}

.dates-container {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  .list {
    display: flex;
    justify-content: center;
    flex-direction: row;
    gap: 1.25rem;

    .item {
      position: relative;
      height: 3rem;
      width: 3rem;
    }
  }

  .label {
    display: flex;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-size: 18px;
    line-height: 20px;
    font-weight: 600;

    &.white {
      color: #ffffff;
    }
  }

  .descriptionContainer {
    display: flex;
    flex-direction: column;
    align-items: center;

    .dueDateDescription {
      font-size: 16px;
      font-weight: 600;
      line-height: 24px;
      color: #ed0059;
    }

    .bestDayToBuy {
      font-size: 14px;
      font-weight: 400;
      line-height: 20px;
      color: #64748b;
    }
  }
}
</style>
